var map = {
  "./areas/administration/bundleDescription": "217556",
  "./areas/administration/notifications/bundleDescription": "2567",
  "./areas/administration/teams/bundleDescription": "259169",
  "./areas/administration/users/bundleDescription": "439467",
  "./areas/application/bundleDescription": "585676",
  "./areas/assetgroups/bundleDescription": "796874",
  "./areas/assets/bundleDescription": "831187",
  "./areas/assets/monitors/bundleDescription": "98247",
  "./areas/automation/bundleDescription": "756189",
  "./areas/cost/bundleDescription": "633231",
  "./areas/dashboards/bundleDescription": "687991",
  "./areas/incidents/bundleDescription": "489599",
  "./areas/integration/bundleDescription": "6614",
  "./areas/kpi/bundleDescription": "951868",
  "./areas/management/agents/bundleDescription": "745512",
  "./areas/management/bundleDescription": "179617",
  "./areas/reports/bundleDescription": "156481",
  "./areas/services/bundleDescription": "77228",
  "./areas/services/designer/bundleDescription": "835110",
  "./areas/sla/bundleDescription": "761854",
  "./areas/summary/bundleDescription": "685964",
  "./areas/tests/bundleDescription": "973789",
  "./areas/views/bundleDescription": "259010"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = () => (Object.keys(map));
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 120347;
